import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`text-xl md:text-2xl font-bold font-heading transition-colors ${
              isScrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}>
              2pg<span className="text-primary-500">·</span>com
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              } ${location.pathname === '/' ? (isScrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              } ${location.pathname.startsWith('/category') ? (isScrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              游戏分类
            </Link>
            <Link
              to="/articles"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              } ${location.pathname.startsWith('/article') || location.pathname === '/articles' ? (isScrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              攻略资讯
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              } ${location.pathname === '/about' ? (isScrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                isScrolled || !isHome ? 'text-foreground-600 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              登录
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center px-5 py-2 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即注册
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors ${
              isScrolled || !isHome ? 'text-foreground-800' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-800 py-2 cursor-pointer">首页</Link>
            <Link to="/category/all" className="text-sm font-medium text-foreground-800 py-2 cursor-pointer">游戏分类</Link>
            <Link to="/articles" className="text-sm font-medium text-foreground-800 py-2 cursor-pointer">攻略资讯</Link>
            <Link to="/about" className="text-sm font-medium text-foreground-800 py-2 cursor-pointer">关于我们</Link>
            <div className="flex gap-3 pt-2 border-t border-background-200/60">
              <Link to="/about" className="flex-1 text-center py-2 rounded-full text-sm font-medium border border-background-300 text-foreground-700 cursor-pointer">登录</Link>
              <Link to="/about" className="flex-1 text-center py-2 rounded-full text-sm font-semibold bg-primary-500 text-background-50 cursor-pointer">立即注册</Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}